import { render } from "./HandoverNotificationBanner.vue?vue&type=template&id=66239aaf"
import script from "./HandoverNotificationBanner.vue?vue&type=script&lang=js"
export * from "./HandoverNotificationBanner.vue?vue&type=script&lang=js"

import "./HandoverNotificationBanner.vue?vue&type=style&index=0&id=66239aaf&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__